// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"420":"e8ef6d32","507":"a2344811","631":"cd7f1800","692":"20c5ff50","787":"7b5f66dd"}[chunkId] + ".chunk.js";
};